<admin-app-header></admin-app-header>
<div class="container-fluid" *ngIf="payoutBatch">
    <div class="row">
        <div class="col-6 d-flex flex-column justify-content-between">
            <h1 class="">Payout Batch: {{ payoutBatch.payoutBatchNumber }}</h1>
            <div>
                Status:
                <span [ngClass]="EnumNames.getPayoutBatchStatusClass(payoutBatch.status)" class="badge">
                    {{ payoutBatch.status }}
                </span>
            </div>
            <div>
                Payout Date:
                <ng-container *ngIf="payoutBatch.payoutDate">
                    {{ payoutBatch.payoutDate.toDate() | date: 'dd MMM yyyy' }}
                </ng-container>
            </div>
            <div>Merchants: {{ payoutBatch.merchantRefs.length }}</div>
            <div>Invoices: {{ payoutBatch.invoiceRefs.length }}</div>
        </div>
        <div class="col-6 p-3">
            <ng-container *ngIf="payoutBatch.status === PayoutBatchStatusEnum.DUE">
                <button class="btn btn-success text-white me-1" (click)="completePayoutBatch()">Mark ALL Proformas as Paid</button>
                <button class="btn bg-standard-bank me-1" (click)="exportStandardBankCSV()">UNTESTED: Bank Export</button>
                <button class="btn btn-danger float-end" (click)="deletePayoutBatch()">Delete Payout Batch</button>
            </ng-container>
        </div>
    </div>
    <div class="content col-lg-12">
        <table class="table table-striped table-sm">
            <thead>
                <tr>
                    <th scope="col">Status</th>
                    <th scope="col">Proforma</th>
                    <th scope="col">Invoices</th>
                    <th scope="col">Merchant</th>
                    <th scope="col">Beneficiary</th>
                    <th scope="col">Bank</th>
                    <th scope="col">Account Type</th>
                    <th scope="col">Account Holder Name</th>
                    <th scope="col">Account Number</th>
                    <!-- <th scope="col">Payout Frequency</th> -->
                    <th scope="col">Total Amount</th>
                    <th scope="col">Payout Amount</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let payout of payouts">
                    <td>
                        <span [ngClass]="EnumNames.getPayoutStatusClass(payout.status)" class="badge">
                            {{ payout.status }}
                        </span>
                    </td>
                    <td>
                        <a [routerLink]="payout.$key ? ['/admin/payout/', payout.$key] : null" class="text-decoration-underline"> PFI-{{ payout.payoutNumber }} </a>
                    </td>
                    <td>{{ payout.invoiceRefs.length }}</td>
                    <td>
                        <a [routerLink]="['/merchant', payout.$merchant?.$key]" class="text-decoration-underline">{{ payout.$merchant?.companyName }}</a>
                    </td>
                    <td>{{ payout.$merchant?.payoutDetails?.beneficiaryName }}</td>
                    <td>{{ payout.$merchant?.payoutDetails?.bank }}</td>
                    <td>{{ payout.$merchant?.payoutDetails?.accountType }}</td>
                    <td>{{ payout.$merchant?.payoutDetails?.accountHolderName }}</td>
                    <td>{{ payout.$merchant?.payoutDetails?.accountNumber }}</td>
                    <!-- <td>
                        <span
                            [routerLink]="['/merchant/', payout.$merchant?.$key, 'profile', 'payout']"
                            class="badge"
                            [ngClass]="{
                                ' bg-success': payout.$merchant?.payoutDetails?.payoutFrequency === PayoutFrequencyEnum.IMMEDIATE,
                                ' bg-warning': payout.$merchant?.payoutDetails?.payoutFrequency === PayoutFrequencyEnum.MONTHLY
                            }"
                        >
                            {{ payout.$merchant?.payoutDetails?.payoutFrequency }}
                        </span>
                    </td> -->
                    <td>{{ payout.totalAmount | currency: 'R' }}</td>
                    <td>{{ payout.payoutAmount | currency: 'R' }}</td>
                </tr>
            </tbody>
        </table>
    </div>
</div>
